<div class="splash-screen">
    <div class="splash-pattern"></div>
    <div class="logo-container">
        <div class="logo-text">SAL Onboarding</div>
        <div id="loading"></div>
        <div class="tagline">Orchestrating data streams… initializing.</div>
    </div>
    <div class="powered-by">Powered by Avalon</div>
</div>
